import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

export default function NotFound() {
  const { t } = useTranslation();
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-background-50 px-4">
      <div className="text-center">
        <div className="w-20 h-20 mx-auto mb-6 rounded-full bg-background-200 flex items-center justify-center">
          <i className="ri-error-warning-line text-3xl text-foreground-500" />
        </div>
        <h1 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
          {t('notfound_title')}
        </h1>
        <p className="text-foreground-600 mb-8 max-w-md">
          {t('notfound_desc')}
        </p>
        <Link
          to="/"
          className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-white text-sm font-medium rounded-lg hover:bg-primary-600 transition-colors"
        >
          <i className="ri-arrow-left-line" />
          {t('notfound_back')}
        </Link>
      </div>
    </div>
  );
}